// The visitor's Maps draft, kept in this browser until they sign up: where their site is and which example's template they looked at.
// After sign-up the same facts reach the server (see `MapSignupController#save_state`), so they land in their own site.
const KEY = "ge.maps.draft"

export function readDraft() {
  try {
    return JSON.parse(window.localStorage.getItem(KEY) || "null")
  } catch {
    return null
  }
}

export function writeDraft(draft) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ ...draft, savedAt: Date.now() }))
  } catch {
    // A browser that will not keep it (private mode, full) just has no draft; nothing depends on it.
  }
}
